import { Markdown } from "@qws-org/ui-kit";
import type { FC } from "react";

import type { SecondaryFooterProps } from "~/features/secondary-footer/SecondaryFooter";

export const FooterDescription: FC<SecondaryFooterProps> = ({ data }) => {
  const mobileDescription = data?.translations?.[0]?.mobile_description ?? "";
  const tabletDescription =
    data?.translations?.[0]?.tablet_description ?? mobileDescription;
  const desktopDescription =
    data?.translations?.[0]?.desktop_description ?? tabletDescription;
  return (
    <>
      {data?.translations?.[0]?.licenses && (
        <Markdown display="block" clobberPrefix={""}>
          {data?.translations?.[0]?.licenses}
        </Markdown>
      )}
      <Markdown display="block" md={{ display: "hidden" }}>
        {mobileDescription}
      </Markdown>
      <Markdown
        display="hidden"
        md={{ display: "block" }}
        d={{ display: "hidden" }}
      >
        {tabletDescription}
      </Markdown>
      <Markdown
        display="hidden"
        md={{ display: "hidden" }}
        d={{ display: "block" }}
      >
        {desktopDescription}
      </Markdown>
    </>
  );
};
